export const RECT_TOOL_ID = "rectangle";

const drawRect = ({ ctx, from, to }) => {
  const width = to.x - from.x;
  const height = to.y - from.y;
  ctx.strokeRect(from.x, from.y, width, height);
};

export const rectToolConfig = {
  id: RECT_TOOL_ID,
  usesPreview: true,
  cursor: "crosshair",
  onStart: () => true,
  onMove: ({ ctx, lastPointRef, nextPoint }) => {
    drawRect({ ctx, from: lastPointRef.current, to: nextPoint });
  },
  onEnd: ({ ctx, lastPointRef, endPoint }) => {
    drawRect({ ctx, from: lastPointRef.current, to: endPoint });
  },
};

const RectToolButton = ({ activeTool, onSelectTool }) => {
  return (
    <button
      type="button"
      className={`btn ${
        activeTool === RECT_TOOL_ID ? "btn-dark" : "btn-outline-dark"
      }`}
      onClick={() => onSelectTool(RECT_TOOL_ID)}
      title="Rectangle"
      aria-label="Rectangle"
    >
      ▭
    </button>
  );
};

export default RectToolButton;
